import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TechServicesComponent } from './components/tech-services.component';
import { DiscountOffersSectionComponent } from './components/discount-offers/discount-offers-section.component';
import { TechServicesCardComponent } from './components/discount-offers/tech-services-card/tech-services-card.component';
import { TechServicesModalComponent } from './components/discount-offers/tech-services-modal/tech-services-modal.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SpeedTestComponent } from './components/speed-test/speed-test.component';
import { TechServicesTabsComponent } from './components/discount-offers/tech-services-tabs/tech-services-tabs.component';
import { OfferContentComponent } from './components/discount-offers/offer-content/offer-content.component';
import { OfferTableComponent } from './components/discount-offers/offer-table/offer-table.component';
import { TechServicesEmailModalComponent } from './components/discount-offers/tech-services-email-modal/tech-services-email-modal.component';
import { MatDialogRef } from '@angular/material/dialog';


@NgModule({
  declarations: [
    TechServicesComponent,
    DiscountOffersSectionComponent,
    TechServicesCardComponent,
    TechServicesModalComponent,
    SpeedTestComponent,
    TechServicesTabsComponent,
    OfferContentComponent,
    OfferTableComponent,
    TechServicesEmailModalComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {}
    }
  ]
})
export class TechServicesModule { }
